// TEMPORARY: Hide this section until popular articles come from real collection/article slugs.
export function TopHits() {
  return null
}
